// extracted by mini-css-extract-plugin
export default {"mainservices":"Services_mainservices__+m2Jq","services":"Services_services__76OeW"};